module.exports = __webpack_public_path__ + "img/广告-5 - 暗渡陈仓.a44f8765.jpg";